<template>
    <div v-if="showNotes" class="notes preview">
        <div class="title">
            {{ noteType === 'Terms' ? $t('OrderNote.Terms') : $t('OrderNote.Notes') }}
        </div>

        <div class="display-notes">
            <div class="print">
                {{ notes }}
            </div>
            <div v-if="showAllNotes" class="show-all" @click="toggleNotes">
                <div>{{ notes }}</div>
                <div v-if="canToggleNotes" class="show-more">
                    {{ $t('OrderNote.less') }}
                </div>
            </div>
            <div v-else class="show-some" @click="toggleNotes">
                <div>{{ concatNotes }}</div>
                <div v-if="canToggleNotes" class="show-more">
                    {{ $t('OrderNote.more') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderId: Number,
        type: {
            type: String,
            options: ['Quote', 'Invoice'],
            default: 'Quote',
        },
        noteType: {
            type: String,
            options: ['Notes', 'Terms'],
            default: 'Notes',
        },
        modelValue: String,
    },

    data() {
        return {
            notes: this.modelValue,
            allNotesShown: false,
            concatCutoff: 300,
            maxLength: 65000,
        };
    },

    computed: {
        showNotes() {
            return Boolean(this.orderId && this.notes);
        },

        showAllNotes() {
            return this.allNotesShown || this.notes.length < this.concatCutoff;
        },

        canToggleNotes() {
            return this.notes.length > this.concatCutoff;
        },

        concatNotes() {
            return `${this.notes.substr(0, this.concatCutoff)}...`;
        },
    },

    methods: {
        toggleNotes() {
            this.allNotesShown = !this.allNotesShown;
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/common';

    .print {
        display: none;
    }

    .mobile {
        display: none;
    }

    .notes {
        margin-bottom: $spacing-400;
        display: flex;
        flex-direction: column;
    }

    .placeholder {
        color: $color-gray-600;
    }

    .show-more {
        margin-top: $spacing-100;
        cursor: pointer;
        text-align: center;
    }

    .display-notes {
        font-size: $font-size-md;
        white-space: pre-wrap;
    }

    .title {
        font-weight: $font-weight-bold;
        font-size: $font-size-md;
        margin-bottom: $spacing-050;
    }

    .textarea {
        --input-margin-bottom: 0;
        --textarea-min-height: #{px-to-rem(90px)};
    }

    @media print {
        .show-all,
        .show-some {
            display: none;
        }

        .print {
            display: block;
        }
    }

    @media only screen and ($small) {
        .preview {
            .notes {
                margin-bottom: $spacing-200;
            }
        }
    }
</style>
